export default __webpack_public_path__ + "static/media/NoticeIcon.f20bc04b.svg";